import React from "react";
import { motion } from "framer-motion";
import { Lock, Activity, Gauge, RefreshCw, LifeBuoy } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, StaggerGroup, staggerItem } from "./Reveal";
import { CountUp } from "./CountUp";

const ICONS = [Lock, Activity, Gauge, RefreshCw, LifeBuoy];

export const TrustPillars = () => {
  const { t } = useLang();
  const p = t.pillars;

  return (
    <section
      data-testid="pillars-section"
      className="relative overflow-hidden py-24 md:py-32 bg-[#0a0a0e] border-y border-white/10"
    >
      <div className="absolute inset-0 grid-lines opacity-30" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tighter text-white">
              {p.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base md:text-lg font-light text-zinc-400">
              {p.subtitle}
            </p>
          </Reveal>
        </div>

        <StaggerGroup
          className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px rounded-2xl overflow-hidden border border-white/10 bg-white/5"
          stagger={0.1}
        >
          {p.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={item.key}
                variants={staggerItem}
                data-testid={`pillar-${i}`}
                className="group relative overflow-hidden bg-[#050507] p-8 min-h-[240px] flex flex-col justify-between transition-colors duration-500 hover:bg-[#0a0a12]"
              >
                <CountUp
                  end={i + 1}
                  pad={2}
                  duration={1.2}
                  className="pointer-events-none absolute -bottom-6 -right-2 font-display text-8xl font-bold leading-none text-white/[0.04] transition-colors duration-500 group-hover:text-[#0047ff]/20"
                />
                <Icon className="relative h-8 w-8 text-[#00e5ff] transition-transform duration-500 group-hover:-translate-y-1" />
                <div className="relative">
                  <h3 className="font-display text-lg font-semibold tracking-wide text-white">
                    {item.key}
                  </h3>
                  <p className="mt-2 text-sm font-light leading-relaxed text-zinc-400">
                    {item.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
};
